<template>
  <div class="equipment-info-module" v-if="showEquipmentByDormitory">
    <div class="content">
      <div class="code">
        <template v-if="equipmentByDormitory.Type === '智能空调'">
          <svg-icon icon-class="智能空调"></svg-icon>&nbsp;
        </template>
        {{ equipmentByDormitory.Type === '智能空调' ? equipmentByDormitory.DeviceSn : equipmentByDormitory.QRCode }}
      </div>
<!--      <div class="name">{{ equipmentByDormitory.BizEquipmentVersionInfo.FullName }}</div>-->
      <div class="type">
        <span :style="{backgroundColor: validOrder.IsReceive ? '#018AFA' : '#E73B3B', marginRight: '10px'}">{{validOrder.IsReceive ? '遥控器已领' : '遥控器未领'}}</span>
<!--        <svg-icon style="width: 20px;height: 20px;margin-top: 2px;margin-right: 10px" :color="validOrder.IsReceive ? '#67C23A' : '#909399'" icon-class="空调遥控器"></svg-icon>-->
        <template v-if="ykq">
          <span v-if="equipmentByDormitory.Type !== '智能空调'" :style="{backgroundColor: equipmentByDormitory.Type === '智能空调' ? '#19D632' : '#EBAD01'}">{{equipmentByDormitory.Type}}</span>
          <span v-else @click="clickItem" :style="{backgroundColor: equipmentByDormitory.Type === '智能空调' ? '#19D632' : '#EBAD01'}">
          <svg-icon icon-class="遥控器" color="#ffffff"></svg-icon>
          遥控器
        </span>
        </template>
        <span v-else :style="{backgroundColor: equipmentByDormitory.Type === '智能空调' ? '#19D632' : '#EBAD01'}">{{equipmentByDormitory.Type}}</span>
        <span :style="{
              backgroundColor: equipmentByDormitory.State === '已锁定' ? '#E73B3B' : equipmentByDormitory.State === '已开通' ? '#018AFA' : '#959595' }">{{equipmentByDormitory.State}}</span>
      </div>
    </div>
    <div class="link" v-if="equipmentByDormitory.Type === '智能空调' && isRightBtn" @click="clickItem">
      <svg-icon icon-class="智能遥控器" color="#ffffff"></svg-icon>
      <div>遥控</div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'equipmentInfoModule',
  props: {
    ykq: {
      type: Boolean,
      default: () => false
    },
    isRightBtn: {
      type: Boolean,
      default: () => false
    },
    orderInfo: Object
  },
  data() {
    return{
      showEquipmentByDormitory: false,
      equipmentByDormitory: {
        BizEquipmentVersionInfo: {}
      },
      validOrder: {
        BizOrderPackageInfo: {},
        BizDormitoryInfo: {}
      },
    }
  },
  methods: {
    clickItem() {
      this.$emit('click', this.equipmentByDormitory)
    },
    async getEquipmentByDormitory() {
      this.showEquipmentByDormitory = false
      try {
        const { Data } = await this.$post('/BizMemberEquipment/EquipmentByDormitory')
        this.equipmentByDormitory = Data
        this.showEquipmentByDormitory = !!Data
        this.$emit('data', Data || {})
      }catch (e) {
        this.showEquipmentByDormitory = false
      }
    },
    async getValidOrder() {
      try {
        const {Data} = await this.$post('/BizMemberParentOrder/MemberEffectiveParentOrder')
        this.validOrder = Data
      } catch (e) {
      }
    },
  },
  mounted() {
    this.getEquipmentByDormitory()
    if (!this.orderInfo) {
      this.getValidOrder()
    }else {
      this.validOrder = this.orderInfo
    }
  }
}

</script>

<style scoped lang="less">
.equipment-info-module{
  border-radius: 10px;
  padding: 10px;
  background-color: #ffffff;
  display: flex;

  .content{
    width: 100%;
    .code{
      display: flex;
      align-items: center;
      color: #A6A6A6;
      margin-bottom: 10px;
    }
    .name{
      margin-bottom: 8px;
      color: #3D3D3D;
      word-wrap: break-word;
      word-break: break-all;
    }
    .type{
      span{
        display: inline-block;
        vertical-align: top;
        margin-right: 10px;
        border-radius: 4px;
        font-size: 12px;
        padding: 2px 6px;
        color: #ffffff;
      }
    }
  }
  .link{
    width: 44px;
    border-radius: 8px;
    flex-shrink: 0;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    background-color: #19D632;
    color: #ffffff;
    >div{
      font-size: 12px;
    }
    .svg-icon{
      font-size: 22px;
      margin-bottom: 2px;
    }
  }
}

</style>
